import { Controller } from "@hotwired/stimulus";
import Swiper from "swiper";
import { Navigation } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/navigation';

export default class extends Controller {
  static values = {
    options: Object,
  };

  connect() {
    const options = {
      ...this.defaultOptions,
      ...this.optionsValue,
    };
    this.swiper = new Swiper(this.element, options);
  }

  disconnect() {
    this.swiper.destroy();
    this.swiper = undefined;
  }

  get defaultOptions() {
    return {
      breakpoints: {
        768: {
          slidesPerView: 3,
          spaceBetween: 24,
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 24,
        },
      },
      modules: [Navigation],
      navigation: {
        disabledClass: "!opacity-60 !cursor-auto",
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      on: {
        afterInit: function(swiper) {
          swiper.el.classList.remove("hidden");
          swiper.el.querySelector('.swiper-wrapper')?.classList.remove("invisible");
          swiper.navigation.prevEl?.classList.remove("hidden");
          swiper.navigation.nextEl?.classList.remove("hidden");
        }
      },
      slidesPerView: 1,
      spaceBetween: 24,
    };
  }
}
